import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { Tag } from '@repo/types';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for featured tags query
const CACHE_TIME = 30 * 60 * 1000;

export const useFeaturedTagsQuery = () => {
  return useQuery({
    queryKey: ['featured-tags'],
    queryFn: fetchFeaturedTags,
    staleTime: !accessToken ? CACHE_TIME : undefined,
  });
};

const fetchFeaturedTags: QueryFunction<Tag[], [string]> = async () => {
  const { data } = await axios.get<Tag[]>(API.endpoints.featuredTags);
  return data;
};
